module.exports = __webpack_public_path__ + "img/logo.4c9becd5.png";